module.exports = __webpack_public_path__ + "4be6d901d9f31147efdfef5a83c172ef.png";